import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.prototype.$http = axios;
Vue.use(VueAxios, axios);
export default VueAxios